import { Injectable } from '@angular/core';
import { UserInfo } from 'angular-oauth2-oidc/types';
import { OAuthService } from 'angular-oauth2-oidc';

import { UserProfile } from '@aes/core/auth/auth.models';
import { Subject } from 'rxjs';
import { AclService } from '@aes/acl/acl.service';

@Injectable({
  providedIn: 'root',
})
export class AesAuthService {
  private authenticated = false;
  private userIdentity: any;
  private authenticationState = new Subject<any>();

  constructor(
    private oauthService: OAuthService,
    private _aclService: AclService) {}

  private userInfoToUserProfile(info: UserInfo): UserProfile {
    return {
      userId: info.sub,
      name: info.name,
      firstName: info.given_name,
      lastName: info.family_name,
      userName: info.preferred_username,
      email: info.email,
      picture: info.picture != null ? info.picture : 'assets/images/avatars/no-avatar.png',
    };
  }

  login(userName, password): Promise<UserProfile> {
    return this.oauthService
      .loadDiscoveryDocument()
      .then(() => {
        return this.oauthService.fetchTokenUsingPasswordFlowAndLoadUserProfile(userName, password).then(info => {
          this._aclService.canAbility(true);
          return this.userInfoToUserProfile(info);
        });
      })
      .catch(err => Promise.reject(err));
  }

  logout(): Promise<void> {
    return this.oauthService.loadDiscoveryDocument().then(() => this.oauthService.revokeTokenAndLogout());
  }

  loadUserProfile(): Promise<UserProfile> {
    return this.oauthService.loadUserProfile().then(info => {
      return this.userInfoToUserProfile(info);
    });
  }

  hasAnyAuthority(authorities: string[]): boolean {
    if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
      return false;
    }

    return authorities.some((authority: string) => this.userIdentity.authorities.includes(authority));
  }
}
